import service from "./request";


window.back=function(){
  this.$router.go(-1);
}

//通过js调用原生的一些方法
export default {
  //js调用获取客户端容器的值
  getNativeValue:function(key){
    this.nativeValue=window.external.getData(key);
    return this.nativeValue;
  },
  //js调用退出登录
  logout(){
    window.external.logout();
  },
  //js调用指纹接口
  fingerprint(methodName) {
    window.external.fingerprint(methodName);
  },
  hideNativeLoading(){
    if(true){
      window.external.hideStartLoading();
    }
  }
}

